import { expressCheckoutMorePaymentOptionsButtonClicked as expressCheckoutMorePaymentOptionsButtonClickedOriginal } from '@wix/bi-logger-payments-data/v2';
import { type expressCheckoutMorePaymentOptionsButtonClickedParams as expressCheckoutMorePaymentOptionsButtonClickedParamsOriginal } from '@wix/bi-logger-payments-data/v2/types';
import { type Origin } from './types';

export type expressCheckoutMorePaymentOptionsButtonClickedParams =
  expressCheckoutMorePaymentOptionsButtonClickedParamsOriginal & {
    origin: Origin;
  };

export const expressCheckoutMorePaymentOptionsButtonClicked: (
  p: expressCheckoutMorePaymentOptionsButtonClickedParams,
) => ReturnType<typeof expressCheckoutMorePaymentOptionsButtonClickedOriginal> =
  expressCheckoutMorePaymentOptionsButtonClickedOriginal;
